import { CloudUpload, ServerCog, DatabaseBackup, Puzzle, ShieldEllipsis, Activity } from 'lucide-react';
import Card from '@/components/common/ui/Card';

const plans = [
    {
        title: "Cloud Migration",
        description: "Seamlessly transition your existing infrastructure to the cloud with minimal downtime. Our experts ensure a smooth migration process tailored to your unique requirements.",
        icon: CloudUpload,
    },
    {
        title: "Cloud Infrastructure Management",
        description: "From setup to maintenance, we manage your cloud infrastructure, allowing you to focus on your core business operations without the hassle of technical management.",
        icon: ServerCog,
    },
    {
        title: "Data Backup and Disaster Recovery",
        description: "Protect your business with our reliable backup solutions and disaster recovery plans. Ensure business continuity even in the face of unforeseen events.",
        icon: DatabaseBackup,
    },
    {
        title: "Custom Cloud Solutions",
        description: "We understand that every business is unique. Our team will work with you to design custom cloud solutions that meet your specific needs and goals.",
        icon: Puzzle,
    },
    {
        title: "Cloud Security Services",
        description: "Safeguard your data with our advanced cloud security services. We provide continuous monitoring and threat assessment to keep your information secure.",
        icon: ShieldEllipsis,
    },
    {
        title: "Cloud Monitoring & Optimization",
        description: "Maximize the performance and efficiency of your cloud environment with real-time monitoring and optimization.",
        icon: Activity,
    }
];

export default function CloudServices() {
    return (
        <section className="container pb-24 pt-12">
            <div className="text-center">
                <h3 className="text-2xl md:text-4xl font-bold text-white leading-tight mb-12">
                    Our Cloud Services
                </h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
                {plans.map((plan, index) => (
                    <Card
                        key={index}
                        title={plan.title}
                        description={plan.description}
                        icon={plan.icon}
                    />
                ))}
            </div>
        </section>
    );
}